<template>
  <div>
    <h1>Online-Karte</h1>
    <p>
      Diese Online-Karte zeigt alle bisher freigegebenen Fotos
      in der Datenbank des Projekts LinguaSnappHamburg.
      Mit den Suchoptionen links und unterhalb der Karte können
      Fotos nach verschiedenen Kriterien recherchiert und angezeigt werden.
      Neben der Karte steht auch eine tabellarische Ansicht zur Verfügung.
    </p>
    <p>
      Klicke auf die Schaltflächen, um mehr als eine Suchoption anzuwählen
      oder eine Suchoption aufzuheben. Klicke auf die einzelnen Suchergebnisse,
      um mehr Information anzuzeigen.
    </p>
  </div>
</template>

<script>
export default {
    name: 'MapIntroduction',
};
</script>

<style scoped>

</style>
